export default function getEnv (name) {
  const envMap = {
    API: process.env.API,
    BUGSNAG_API_KEY: process.env.BUGSNAG_API_KEY,
    NODE_ENV: process.env.NODE_ENV,
    GOOGLE_API: process.env.GOOGLE_API,
    PAPER_WEB: process.env.PAPER_WEB,
    GTAG_ID: process.env.GTAG_ID,
    THUMBOR_URL: process.env.THUMBOR_URL,
    ASSETS_BUCKET: process.env.ASSETS_BUCKET,
    VAT: process.env.VAT,
    get VAT_PERCENTAGE () {
      return `${this.VAT}%`
    }
  }

  return window?.configs?.[name] || envMap[name]
}
